module.exports = __webpack_public_path__ + "static/media/BTT-BUSD.70b59e26.png";